/**
 * Homepage products configuration file
 * Centralized management of all product information with i18n support
 */

export const homeProductsConfig = {
  // Product categories
  categories: [
    {
      id: 'official',
      nameKey: 'homepage.categories.official.name',
      descriptionKey: 'homepage.categories.official.description',
      products: [
        {
          id: 'gpt-official',
          productId: 240,
          type: 'gpt',
          nameKey: 'homepage.products.gpt.name',
          image: '/images/gpt-main.jpg',
          price: 17.9,
          originalPrice: 20,
          currency: '$',
          billingPeriod: 'month',
          features: {
            platform: 'web', // web, app, web+app
            users: 1, // number of users
            loginType: 'official', // official, shared, custom
            warranty: 'lifetime', // lifetime, monthly, none
          },
          descriptionKey: 'homepage.products.gpt.description',
          highlights: [
            'homepage.products.gpt.highlight1',
            'homepage.products.gpt.highlight2'
          ]
        }
      ]
    },
    {
      id: 'official-renewal',
      nameKey: 'homepage.categories.officialRenewal.name',
      descriptionKey: 'homepage.categories.officialRenewal.description',
      products: [
        {
          id: 'gpt-renew-official',
          productId: 243,
          type: 'renew',
          nameKey: 'homepage.products.gptRenew.name',
          image: '/images/renew-main.jpg',
          price: 17.9,
          originalPrice: 20,
          currency: '$',
          billingPeriod: 'month',
          features: {
            platform: 'web',
            users: 1,
            loginType: 'official',
            warranty: 'lifetime',
          },
          descriptionKey: 'homepage.products.gptRenew.description',
          highlights: [
            'homepage.products.gptRenew.highlight1',
            'homepage.products.gptRenew.highlight2'
          ]
        }
      ]
    },
    {
      id: 'official-shared',
      nameKey: 'homepage.categories.officialShared.name',
      descriptionKey: 'homepage.categories.officialShared.description',
      products: [
        {
          id: 'gpt-official-shared-3',
          productId: 246,
          type: 'gpt',
          nameKey: 'homepage.products.gptOfficialShared.name',
          image: '/images/gpt/3.jpg',
          price: 9.9,
          originalPrice: 20,
          currency: '$',
          billingPeriod: 'month',
          features: {
            platform: 'web',
            users: 3,
            loginType: 'official',
            warranty: 'lifetime',
          },
          descriptionKey: 'homepage.products.gptOfficialShared.description',
          highlights: [
            'homepage.products.gptOfficialShared.highlight1',
            'homepage.products.gptOfficialShared.highlight2'
          ]
        },
        {
          id: 'gpt-official-shared-6',
          productId: 249,
          type: 'gpt',
          nameKey: 'homepage.products.gptOfficialShared6.name',
          image: '/images/gpt/6.jpg',
          price: 4.9,
          originalPrice: 20,
          currency: '$',
          billingPeriod: 'month',
          features: {
            platform: 'web',
            users: 6,
            loginType: 'official',
            warranty: 'lifetime',
          },
          descriptionKey: 'homepage.products.gptOfficialShared6.description',
          highlights: [
            'homepage.products.gptOfficialShared6.highlight1',
            'homepage.products.gptOfficialShared6.highlight2'
          ]
        }
      ]
    },
    // {
    //   id: 'shared',
    //   nameKey: 'homepage.categories.shared.name',
    //   descriptionKey: 'homepage.categories.shared.description',
    //   products: [
    //     {
    //       id: 'gpt-shared',
    //       productId: 252,
    //       type: 'gpt',
    //       nameKey: 'homepage.products.gpt.name',
    //       image: '/images/gpt-main.jpg',
    //       price: 4.9,
    //       originalPrice: 20,
    //       currency: '$',
    //       billingPeriod: 'month',
    //       features: {
    //         platform: 'web',
    //         users: 1, // 1 person exclusive
    //         loginType: 'shared',
    //         warranty: 'monthly',
    //       },
    //       descriptionKey: 'homepage.products.gpt.shared.description',
    //       highlights: [
    //         'homepage.products.shared.highlight1',
    //         'homepage.products.shared.highlight2'
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'monkeyai',
    //   nameKey: 'homepage.categories.monkeyai.name',
    //   descriptionKey: 'homepage.categories.monkeyai.description',
    //   products: [
    //     {
    //       id: 'monkeyai-monthly',
    //       productId: 255,
    //       type: 'monkeyai',
    //       nameKey: 'homepage.products.monkeyai.name',
    //       image: '/images/monkeyai-main.jpg',
    //       price: 9.9,
    //       originalPrice: 19.9,
    //       currency: '$',
    //       billingPeriod: 'month',
    //       duration: 1,
    //       features: {
    //         platform: 'web+app',
    //         users: 1,
    //         loginType: 'custom',
    //         warranty: 'lifetime',
    //       },
    //       descriptionKey: 'homepage.products.monkeyai.description',
    //       highlights: [
    //         'homepage.products.monkeyai.highlight1',
    //         'homepage.products.monkeyai.highlight2',
    //         'homepage.products.monkeyai.highlight3'
    //       ]
    //     }
    //   ]
    // }
  ],

  // Product type icons and color configuration
  productStyles: {
    gpt: {
      icon: 'Globe',
      gradient: 'from-green-500 to-green-600',
      color: 'green'
    },
    claude: {
      icon: 'Globe',
      gradient: 'from-purple-500 to-purple-600',
      color: 'purple'
    },
    sora: {
      icon: 'Globe',
      gradient: 'from-blue-500 to-blue-600',
      color: 'blue'
    },
    grok: {
      icon: 'Globe',
      gradient: 'from-orange-500 to-orange-600',
      color: 'orange'
    },
    app: {
      icon: 'Smartphone',
      gradient: 'from-gray-700 to-gray-900',
      color: 'gray'
    },
    monkeyai: {
      icon: 'Smartphone',
      gradient: 'from-purple-500 to-indigo-600',
      color: 'purple'
    }
  },

  // Table display configuration
  tableColumns: {
    productName: { key: 'productName', width: 'col-span-3' },
    price: { key: 'price', width: 'col-span-1' },
    users: { key: 'users', width: 'col-span-1' },
    loginType: { key: 'loginType', width: 'col-span-2' },
    warranty: { key: 'warranty', width: 'col-span-1' },
    originalPrice: { key: 'originalPrice', width: 'col-span-1' },
    description: { key: 'description', width: 'col-span-2' },
    action: { key: 'action', width: 'col-span-1' }
  },

  // Background gradient configuration (for product cards)
  cardGradients: [
    'from-blue-50 to-purple-50',
    'from-pink-50 to-rose-50',
    'from-purple-50 to-indigo-50',
    'from-red-50 to-pink-50',
    'from-amber-50 to-orange-50',
    'from-teal-50 to-green-50',
    'from-indigo-50 to-blue-50',
    'from-fuchsia-50 to-pink-50'
  ]
};

// Utility functions
export const getProductsByCategory = (categoryId) => {
  const category = homeProductsConfig.categories.find(cat => cat.id === categoryId);
  return category ? category.products : [];
};

export const getProductById = (productId) => {
  for (const category of homeProductsConfig.categories) {
    const product = category.products.find(p => p.productId === productId);
    if (product) return product;
  }
  return null;
};

export const getProductStyle = (type) => {
  return homeProductsConfig.productStyles[type] || homeProductsConfig.productStyles.gpt;
};

export const getCardGradient = (index) => {
  const gradients = homeProductsConfig.cardGradients;
  return gradients[index % gradients.length];
};

// 根据产品ID获取首页配置的产品图片
export const getHomeProductImage = (productId) => {
  const numericProductId = parseInt(productId);
  
  // 首先直接查找产品
  for (const category of homeProductsConfig.categories) {
    const product = category.products.find(p => p.productId === numericProductId);
    if (product) {
      return product.image;
    }
  }
  
  // 如果没找到，检查是否是12个月版本，查找对应的1个月版本
  const reverseMapping = {
    242: 240, // GPT官方账号(12个月) → GPT官方账号(1个月)
    245: 243, // GPT续费产品(12个月) → GPT续费产品(1个月)
    248: 246, // GPT官方3人共享(12个月) → GPT官方3人共享(1个月)
    251: 249  // GPT官方6人共享(12个月) → GPT官方6人共享(1个月)
  };
  
  const baseProductId = reverseMapping[numericProductId];
  if (baseProductId) {
    for (const category of homeProductsConfig.categories) {
      const product = category.products.find(p => p.productId === baseProductId);
      if (product) {
        console.log(`产品${numericProductId}使用基础产品${baseProductId}的图片:`, product.image);
        return product.image;
      }
    }
  }
  
  return null;
};

// 根据产品ID获取产品类型
export const getProductTypeByProductId = (productId) => {
  const numericProductId = parseInt(productId);
  for (const category of homeProductsConfig.categories) {
    const product = category.products.find(p => p.productId === numericProductId);
    if (product) {
      return product.type;
    }
  }
  return null;
};

// 根据首页产品ID获取对应的12个月套餐产品ID
export const get12MonthProductId = (homeProductId) => {
  const productIdMapping = {
    240: 242, // GPT官方账号(1个月) → GPT官方账号(12个月)
    243: 245, // GPT续费产品(1个月) → GPT续费产品(12个月)
    246: 248, // GPT官方3人共享(1个月) → GPT官方3人共享(12个月)
    249: 251  // GPT官方6人共享(1个月) → GPT官方6人共享(12个月)
  };
  
  const numericProductId = parseInt(homeProductId);
  return productIdMapping[numericProductId] || numericProductId;
};